"use client";

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthState, User, AuthTokens } from '@/types/auth';
import { isAuthenticated as checkAuth, getAccessToken, getUser as getStoredUser } from '@/lib/auth/tokens';

interface AuthStore extends AuthState {
  setUser: (user: User) => void;
  setTokens: (tokens: AuthTokens) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: getStoredUser(),
      tokens: null,
      isAuthenticated: checkAuth(),
      isLoading: true,
      error: null,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setTokens: (tokens) => set({ tokens }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      clearAuth: () =>
        set({
          user: null,
          tokens: null,
          isAuthenticated: false,
          error: null,
        }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
